module.exports = __webpack_public_path__ + "img/fossil2Img3.70e0b1a0.jpg";